import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { IServiceStatusResponse } from '../api/hooks/useUtilities';
import { useUserServiceStatus } from '../api/hooks/useUtilities';

interface FeatureContextType {
	data: IServiceStatusResponse | undefined;
	isLoading: boolean;
	error: Error | null;
}

const FeatureContext = createContext<FeatureContextType | null>(null);

export const FeatureProvider = ({ children }: { children: ReactNode }) => {
	const { data, isLoading, error } = useUserServiceStatus('swift');

	return (
		<FeatureContext.Provider value={{ data, isLoading, error }}>
			{children}
		</FeatureContext.Provider>
	);
};

export const useFeatureContext = () => {
	const context = useContext(FeatureContext);
	if (context === undefined) {
		throw new Error('useFeatureContext must be used within a FeatureProvider');
	}
	return context;
};
